import { jsx as _ } from "react/jsx-runtime";
import { ai as w, p as D, J, d as L, r as O, aj as R } from "../../vendor-Dd6qj6gJ.js";
import { forwardRef as T, useMemo as V, Fragment as q, memo as z } from "react";
import { isAutoColor as E } from "../../theme/color.js";
import { stupidInvertClasses as G } from "../../utils/index.js";
import { I as K } from "../../iconLoader.gen-CjadCA3f.js";
import { getSpacingClasses as Q } from "../../utils/getSpacingClasses/index.js";
import '../../assets/index4.css';const U = "_xs_svgnk_1", X = "_sm_svgnk_5", Y = "_md_svgnk_9", Z = "_lg_svgnk_13", ss = "_xl_svgnk_17", os = "_baseIcon_svgnk_21", ns = "_moon_svgnk_63", es = "_red_svgnk_67", ts = "_sienna_svgnk_71", as = "_gold_svgnk_75", cs = "_cactus_svgnk_79", rs = "_green_svgnk_83", _s = "_teal_svgnk_87", is = "_blue_svgnk_91", ds = "_purple_svgnk_95", ls = "_magenta_svgnk_99", t = {
  xs: U,
  sm: X,
  md: Y,
  lg: Z,
  xl: ss,
  baseIcon: os,
  moon: ns,
  red: es,
  sienna: ts,
  gold: as,
  cactus: cs,
  green: rs,
  teal: _s,
  blue: is,
  purple: ds,
  magenta: ls
}, ms = T(
  ({
    id: i,
    m: d,
    mt: l,
    mr: m,
    mb: g,
    ml: v,
    p,
    pt: f,
    pr: u,
    pb: b,
    pl: k,
    icon: a,
    description: c,
    color: s,
    __inverted: $,
    size: x = "md",
    className: I,
    slot: h,
    ...o
  }, C) => {
    const e = K[a] ?? "", P = V(() => ({ __html: e }), [e]), y = w(i), n = !!c, { focusProps: B, isFocused: F, isFocusVisible: M } = D(o), { hoverProps: j, isHovered: A } = J(o);
    if (!e)
      return null;
    const r = E(s), H = L(
      t.baseIcon,
      t[x],
      r ? t[s] : void 0,
      Q({ m: d, mb: g, ml: v, mr: m, mt: l, p, pb: b, pl: k, pr: u, pt: f }),
      $ ? G() : void 0,
      I
    ), N = n ? { "aria-label": c, role: "img" } : { "aria-hidden": !0 }, S = n ? {
      "data-focus-visible": M || void 0,
      "data-focused": F || void 0,
      "data-hovered": A || void 0
    } : {}, W = n ? O(o, j, B) : o;
    return /* @__PURE__ */ _(n ? R : q, { children: /* @__PURE__ */ _(
      "span",
      {
        ...W,
        ...N,
        ...S,
        style: s && !r ? { "--icon-color": `var(--${s})` } : void 0,
        slot: h,
        id: y,
        ref: C,
        "data-icon": a,
        className: H,
        dangerouslySetInnerHTML: P
      }
    ) });
  }
), xs = z(ms);
export {
  xs as BaseIcon
};
